<template>
  <div id="suppliers-index" class="container suppliers-index">
    <div style="position: fixed; left: 15px; top: 70px; z-index: 10">
      <button class="btn btn-primary" v-b-toggle.search-and-filter>
        <b-icon icon="filter"></b-icon>
      </button>
    </div>
    <div class="text-center mt-5 mt-md-0">
      <strong class="h3">
        {{ translate('suppliers.title') }}
      </strong>
    </div>
    <hr class="custom-hr" />
    <div
      v-if="isMobile"
      class="d-flex flex-row"
      style="
        position: fixed;
        z-index: 10;
        top: 70px;
        overflow-x: scroll;
        width: 100%;
        right: 10px;
        z-index: 5;
        padding-left: 72px;
      "
    >
      <button
        class="btn btn-primary ml-2"
        :class="{ 'active-letter-mobile': !activeLetter }"
        @click="filterByLetter('')"
        style="width: 46px"
      >
        All
      </button>
      <button
        class="btn btn-primary ml-2"
        v-for="value in letters"
        :class="{ 'active-letter-mobile': value === activeLetter }"
        @click="filterByLetter(value)"
        style="width: 46px"
        :key="value"
      >
        {{ value }}
      </button>
    </div>
    <div v-if="!isMobile" class="d-flex justify-content-center mb-4">
      <strong
        class="text-primary mx-2"
        :class="{ 'active-letter': !activeLetter }"
        @click="filterByLetter('')"
        style="cursor: pointer; font-size: 25px"
      >
        All
      </strong>
      <strong
        class="text-primary mx-2"
        v-for="value in letters"
        :class="{ 'active-letter': value === activeLetter }"
        @click="filterByLetter(value)"
        style="cursor: pointer; font-size: 25px"
        :key="value"
      >
        {{ value }}
      </strong>
    </div>
    <div>
      <b-sidebar
        id="search-and-filter"
        :title="translate('forms.search_and_filter')"
        shadow
      >
        <div class="px-3 py-2">
          <form method="POST" @submit.prevent="getResult">
            <div class="form-group">
              <input
                type="text"
                v-model="form.keyword"
                class="form-control"
                :placeholder="translate('forms.search')"
              />
            </div>
            <div class="form-group mb-2 mt-2">
              <label>{{ translate('forms.specification') }}</label>
              <multiselect
                v-model="selectedSpecifications"
                :placeholder="translate('forms.search')"
                label="name"
                track-by="id"
                :options="initialSpecifications"
                :multiple="true"
                :taggable="false"
                :max-height="150"
                :limit="4"
                :showLabels="false"
                :loading="isSpecificationsLoading"
              ></multiselect>
            </div>
            <div class="form-group mb-2 mt-2">
              <label>{{ translate('forms.services') }}</label>
              <multiselect
                v-model="selectedServices"
                :placeholder="translate('forms.search')"
                label="name"
                track-by="id"
                :options="initialServices"
                :multiple="true"
                :taggable="false"
                :max-height="150"
                :limit="4"
                :showLabels="false"
                :loading="isServicesLoading"
              ></multiselect>
            </div>
            <div class="form-group">
              <label>{{ translate('forms.communities') }}</label>
              <multiselect
                v-model="selectedCommunities"
                :placeholder="translate('forms.search')"
                label="name"
                track-by="id"
                :options="initialCommunities"
                :multiple="true"
                :taggable="false"
                :max-height="150"
                :limit="4"
                :showLabels="false"
                :loading="isCommunitiesLoading"
              ></multiselect>
            </div>
            <button class="btn btn-primary float-right" type="submit">
              {{ translate('buttons.get_result') }}
            </button>
            <button
              class="btn btn-primary float-right mr-2"
              type="button"
              @click="reset"
            >
              {{ translate('buttons.clear') }}
            </button>
          </form>
        </div>
      </b-sidebar>
    </div>
    <suppliers-grid
      :suppliers="suppliers"
      v-if="suppliers.length"
    ></suppliers-grid>
    <ContentLoader v-if="!suppliers.length && !noData" />
    <div v-if="!suppliers.length && noData">
      <NoData
        :message="translate('fallback-messages.no_data_found')"
        class="text-center"
      />
    </div>

    <!-- <div class="text-center mt-5" v-if="suppliers.length">
      <b-button
        pill
        size="sm"
        style="margin: 2px"
        @click="filterByLetter('')"
        :class="{ 'active-letter': !activeLetter }"
        variant="primary"
        >All</b-button
      >
      <b-button
        variant="primary"
        pill
        size="sm"
        v-for="value in letters"
        :key="value"
        style="margin: 2px; width: 30px"
        :class="{ 'active-letter': value === activeLetter }"
        @click="filterByLetter(value)"
        >{{ value }}</b-button
      >
    </div> -->
  </div>
</template>

<script>
import { getSuppliers } from '@/api/services/supplier'
import { formMultilSelectMixin } from '@/mixins/formMultilSelectMixin'
import SuppliersGrid from '@/components/suppliers/SuppliersGrid'
export default {
  mixins: [formMultilSelectMixin],
  data() {
    return {
      letters: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      suppliers: [],
      isLoading: false,
      form: {
        service: [],
        location: [],
        specifications: [],
        keyword: ''
      },
      activeLetter: '',
      noData: false
    }
  },
  components: { SuppliersGrid },
  methods: {
    getResult() {
      if (this.isMobile) {
        this.$root.$emit('bv::toggle::collapse', 'search-and-filter')
      }
      this.fetchSuppliers()
    },
    async fetchSuppliers() {
      try {
        this.isLoading = true
        this.noData = false
        this.suppliers = []
        let { data } = await getSuppliers(this.form)
        this.suppliers = data.data
        if (!this.suppliers.length) {
          this.noData = true
        }
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    reset() {
      this.form = {
        services: [],
        communities: [],
        keyword: ''
      }
      this.fetchSuppliers()
    },
    filterByLetter(letter) {
      this.$router.replace({ path: 'suppliers', query: { keyword: letter } })
      this.$router.go(this.$router.currentRoute)
      this.activeLetter = letter
      this.form.keyword = letter
      this.fetchSuppliers()
    }
  },
  watch: {
    selectedServices: {
      immediate: true,
      handler(values) {
        this.form.service = values.map((x) => x.id)
      }
    },
    selectedCommunities: {
      immediate: true,
      handler(values) {
        this.form.location = values.map((x) => x.name)
      }
    },
    selectedSpecifications: {
      immediate: true,
      handler(values) {
        this.form.specifications = values.map((x) => x.name)
      }
    }
  },
  mounted() {
    this.activeLetter = this.$route.query.keyword || ''
    this.form.keyword = this.$route.query.keyword || ''
    this.fetchSuppliers()
    this.getServicesList()
    this.getCommunitiesList()
    this.getSpecificationsList()
  }
}
</script>

<style scoped lang="scss">
.active-letter {
  color: #d28121 !important;
}
.active-letter-mobile {
  background: #d28121;
  border-color: #d28121;
  color: #fff;
}
.custom-hr {
  border: none;
  height: 4px;
  background: #ff9a21;
  width: 200px;
  margin-bottom: 20px;
}
// @media (min-width: 320px) {
//   .supplier-social {
//     text-align: left !important;
//     margin-bottom: 4px;
//   }
//   .supplier-card {
//     margin-bottom: 10px;
//   }
//   .mobile-letter-filter {
//     position: fixed;
//     z-index: 1;
//     right: 0;
//     margin-right: 14px;
//     overflow: scroll;
//     height: 90vh;
//     margin-top: -40px !important;
//   }
// }
.suppliers-index {
  padding-bottom: 100px;
}
</style>
